import React from 'react';

import LocationInput from 'components/LocationInput';

type Props = {
  id?: string;
  name?: string;
  hasError: boolean;
  placeholder?: string;
  locationText: string | null | undefined;
  onClear: (arg0: SearchLocation | null | undefined) => void;
  onChange: (arg0: SearchLocation | null | undefined) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: (...args: Array<any>) => any;
  showClearButton: boolean;
  className?: string;
  disabled?: boolean;
  includeFull?: boolean;
  addressTypes?: Array<string>;
  componentRestrictions?: Record<string, string | Array<string>>;
};
type State = {
  locationInputValue: string;
  prevPropsLocationText: string | null | undefined;
};

class LocationInputContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    showClearButton: false,
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    locationInputValue: this.props.locationText || '',
    // eslint-disable-next-line react/destructuring-assignment
    prevPropsLocationText: this.props.locationText,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    // if the search location changes in the Redux store, update the
    // search input with the new value
    if (props.locationText !== state.prevPropsLocationText) {
      return {
        locationInputValue: props.locationText || '',
        prevPropsLocationText: props.locationText,
      };
    }

    return null;
  }

  clearLocation = () => {
    this.setState({
      locationInputValue: '',
    });

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.onClear) {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.onClear();
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(undefined);
  };

  onLocationInputValueChange = (
    e: InputEvent,
    {
      newValue,
    }: {
      newValue: string;
    }
  ) => {
    if (newValue === '') {
      this.clearLocation();
    }

    this.setState({
      locationInputValue: newValue,
    });
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line consistent-return
  onBlur = (e: FocusEvent) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.onBlur) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      return this.props.onBlur(e);
    }

    const { locationInputValue } = this.state;

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (locationInputValue && locationInputValue !== this.props.locationText) {
      this.clearLocation();
    }
  };

  render() {
    const {
      addressTypes,
      hasError,
      locationText,
      onChange,
      className,
      componentRestrictions,
      ...inputProps
    } = this.props;
    return (
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onBlur: (e: FocusEvent) => any; hasError: ... Remove this comment to see the full error message
      <LocationInput
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...inputProps}
        onBlur={this.onBlur}
        hasError={hasError}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        locationInputValue={this.state.locationInputValue}
        showClearButton={
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.showClearButton && !!this.state.locationInputValue
        }
        clearLocation={this.clearLocation}
        onLocationChange={onChange}
        onLocationInputValueChange={this.onLocationInputValueChange}
        className={className}
        addressTypes={addressTypes}
        componentRestrictions={componentRestrictions}
      />
    );
  }
}

export default LocationInputContainer;
